import React from 'react'
import { useState } from 'react';
import { FaRegLifeRing } from "react-icons/fa6";
import { FaRegRegistered } from "react-icons/fa6";
import { FaWhatsapp } from "react-icons/fa";
import { BiSolidUserBadge } from "react-icons/bi";







// components
import DynamicComponentforAllTrafic from './dynamicComponentforAllTrafic';

const data = ["TOTAL", 0, 0, 0, 0, 0, 0, 0, 0,0,0,0];

function SystemTraffic() {

    const [activeTab, setActiveTab] = useState("WhatsAppTraffic");

    const tabList = [
        
        {
            id: "WhatsAppTraffic", label: "WhatsApp Traffict", icon: <FaWhatsapp />
            , component: <DynamicComponentforAllTrafic Title={'WhatsApp System Traffic Analysis'}Data={data} />
        },
        {
            id: "VoiceTraffic", label: "Voice Traffict", icon: <BiSolidUserBadge />
            , component: <DynamicComponentforAllTrafic Title={'Voice System Traffic Analysis'} Data={data} />
        },
        {
            id: "TTSTraffic", label: "TTS Traffict", icon: <BiSolidUserBadge />
            , component: <DynamicComponentforAllTrafic Title={'TTS System Traffic Analysis'} Data={data} />
        },
        {
            id: "CTCTraffic", label: "CTC Traffic", icon: <BiSolidUserBadge />
            , component: <DynamicComponentforAllTrafic Title={'CTC System Traffic Analysis'} Data={data} />
        },
    ];

    return (
        <>
            <div className='dark:bg-[#121519] h-[100vh]'>
                <div className=' w-[100%] flex md:pt-[70px] gap-1 px-2 pt-[120px] dark:bg-[#121519]  '>
                    {tabList.map((item, index) =>
                        <button
                            onClick={() => setActiveTab(item.id)}
                            className={` w-[16%] rounded-[5px]  py-2 text-[11px] font-bold flex items-center justify-center gap-1 ${activeTab === item.id ? 'bg-[#37715d] text-[#fff]' : 'bg-[#e0e0e0] text-[#333]'} `} > {item.icon}  <span className='md:block hidden'>{item.label}</span>  </button>
                    )
                    }
                </div>
                <div className="pt-4 px-2 dark:bg-[#121519]">
                    {tabList.find((t) => t.id === activeTab)?.component}
                </div>
            </div>
        </>
    )
}

export default SystemTraffic
